import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mt-6">
          Página não encontrada
        </h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-500">
          A página que você procura não existe ou foi movida.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors duration-200"
        >
          <i className="ri-arrow-left-line"></i>
          Voltar ao Início
        </Link>
      </div>
    </div>
  );
}